import { ChainId, JSBI, Percent, Token, WAVAX } from '@yetiswap/sdk'
import { AbstractConnector } from '@web3-react/abstract-connector'

import { injected, walletlink, walletconnect } from '../connectors'

export const ROUTER_ADDRESS: { [chainId in ChainId]: string } = {
  [ChainId.BOBATEST]: '0x262DcFB36766C88E6A7a2953c16F8defc40c378A',
  [ChainId.BOBA]: '0x262DcFB36766C88E6A7a2953c16F8defc40c378A'
}

export const LANDING_PAGE = 'https://docs.yetiswap.app'

export const ZERO_ADDRESS = '0x0000000000000000000000000000000000000000'

// a list of tokens by chain
type ChainTokenList = {
  readonly [chainId in ChainId]: Token[]
}

export const YTS: { [chainId in ChainId]: Token } = {
  [ChainId.BOBATEST]: new Token(ChainId.BOBATEST, '0xA8235EDD84C52Ff3e86CBD4df9ffc6009928Ee39', 18, 'YTS', 'YetiSwap'),
  [ChainId.BOBA]: new Token(ChainId.BOBA, '0xbbc4A8d076F4B1888fec42581B6fc58d242CF2D5', 18, 'YTS', 'YetiSwap')
}

export const BOBA: { [chainId in ChainId]: Token } = {
  [ChainId.BOBATEST]: new Token(ChainId.BOBATEST, '0xa18bF3994C0Cc6E3b63ac420308E5383f53120D7', 18, 'BOBA', 'BOBA'),
  [ChainId.BOBA]: new Token(ChainId.BOBA, '0xa18bF3994C0Cc6E3b63ac420308E5383f53120D7', 18, 'BOBA', 'BOBA')
}

export const USDT: { [chainId in ChainId]: Token } = {
  [ChainId.BOBATEST]: new Token(ChainId.BOBATEST, ZERO_ADDRESS, 6, 'USDT', 'Tether USD'),
  [ChainId.BOBA]: new Token(ChainId.BOBA, ZERO_ADDRESS, 6, 'USDT', 'Tether USD'),
}

export const USDTE: { [chainId in ChainId]: Token } = {
  [ChainId.BOBATEST]: new Token(ChainId.BOBATEST, ZERO_ADDRESS, 6, 'USDT.e', 'Tether USD'),
  [ChainId.BOBA]: new Token(ChainId.BOBA, ZERO_ADDRESS, 6, 'USDT.e', 'Tether USD'),
}

export const WBTC: { [chainId in ChainId]: Token } = {
  [ChainId.BOBATEST]: new Token(ChainId.BOBATEST, ZERO_ADDRESS, 8, 'None', 'None'),
  [ChainId.BOBA]: new Token(ChainId.BOBA, ZERO_ADDRESS, 8, 'None', 'None'),
}

export const LINK: { [chainId in ChainId]: Token } = {
  [ChainId.BOBATEST]: new Token(ChainId.BOBATEST, ZERO_ADDRESS, 18, 'None', 'None'),
  [ChainId.BOBA]: new Token(ChainId.BOBA, ZERO_ADDRESS, 18, 'None', 'None'),
}

export const DAI: { [chainId in ChainId]: Token } = {
  [ChainId.BOBATEST]: new Token(ChainId.BOBATEST, ZERO_ADDRESS, 18, 'None', 'None'),
  [ChainId.BOBA]: new Token(ChainId.BOBA, ZERO_ADDRESS, 18, 'None', 'None'),
}

export const UNI: { [chainId in ChainId]: Token } = {
  [ChainId.BOBATEST]: new Token(ChainId.BOBATEST, ZERO_ADDRESS, 18, 'None', 'None'),
  [ChainId.BOBA]: new Token(ChainId.BOBA, ZERO_ADDRESS, 18, 'None', 'None'),
}

export const SUSHI: { [chainId in ChainId]: Token } = {
  [ChainId.BOBATEST]: new Token(ChainId.BOBATEST, ZERO_ADDRESS, 18, 'None', 'None'),
  [ChainId.BOBA]: new Token(ChainId.BOBA, ZERO_ADDRESS, 18, 'None', 'None'),
}

export const AAVE: { [chainId in ChainId]: Token } = {
  [ChainId.BOBATEST]: new Token(ChainId.BOBATEST, ZERO_ADDRESS, 18, 'None', 'None'),
  [ChainId.BOBA]: new Token(ChainId.BOBA, ZERO_ADDRESS, 18, 'None', 'None'),
}

export const YFI: { [chainId in ChainId]: Token } = {
  [ChainId.BOBATEST]: new Token(ChainId.BOBATEST, ZERO_ADDRESS, 18, 'None', 'None'),
  [ChainId.BOBA]: new Token(ChainId.BOBA, ZERO_ADDRESS, 18, 'None', 'None'),
}

export const PNG: { [chainId in ChainId]: Token } = {
  [ChainId.BOBATEST]: new Token(ChainId.BOBATEST, ZERO_ADDRESS, 18, 'None', 'None'),
  [ChainId.BOBA]: new Token(ChainId.BOBA, ZERO_ADDRESS, 18, 'None', 'None'),
}

export const ELK: { [chainId in ChainId]: Token } = {
  [ChainId.BOBATEST]: new Token(ChainId.BOBATEST, ZERO_ADDRESS, 18, 'None', 'None'),
  [ChainId.BOBA]: new Token(ChainId.BOBA, ZERO_ADDRESS, 18, 'None', 'None'),
}

export const YAK: { [chainId in ChainId]: Token } = {
  [ChainId.BOBATEST]: new Token(ChainId.BOBATEST, ZERO_ADDRESS, 18, 'None', 'None'),
  [ChainId.BOBA]: new Token(ChainId.BOBA, ZERO_ADDRESS, 18, 'None', 'None'),
}

export const AVE: { [chainId in ChainId]: Token } = {
  [ChainId.BOBATEST]: new Token(ChainId.BOBATEST, ZERO_ADDRESS, 18, 'None', 'None'),
  [ChainId.BOBA]: new Token(ChainId.BOBA, ZERO_ADDRESS, 18, 'None', 'None'),
}

export const CNR: { [chainId in ChainId]: Token } = {
  [ChainId.BOBATEST]: new Token(ChainId.BOBATEST, ZERO_ADDRESS, 18, 'None', 'None'),
  [ChainId.BOBA]: new Token(ChainId.BOBA, ZERO_ADDRESS, 18, 'None', 'None'),
}

export const SISTA: { [chainId in ChainId]: Token } = {
  [ChainId.BOBATEST]: new Token(ChainId.BOBATEST, ZERO_ADDRESS, 18, 'None', 'None'),
  [ChainId.BOBA]: new Token(ChainId.BOBA, ZERO_ADDRESS, 18, 'None', 'None'),
}

export const SING: { [chainId in ChainId]: Token } = {
  [ChainId.BOBATEST]: new Token(ChainId.BOBATEST, ZERO_ADDRESS, 18, 'None', 'None'),
  [ChainId.BOBA]: new Token(ChainId.BOBA, ZERO_ADDRESS, 18, 'None', 'None'),
}

export const OLIVE: { [chainId in ChainId]: Token } = {
  [ChainId.BOBATEST]: new Token(ChainId.BOBATEST, ZERO_ADDRESS, 18, 'None', 'None'),
  [ChainId.BOBA]: new Token(ChainId.BOBA, ZERO_ADDRESS, 18, 'None', 'None'),
}

export const PEFI: { [chainId in ChainId]: Token } = {
  [ChainId.BOBATEST]: new Token(ChainId.BOBATEST, ZERO_ADDRESS, 18, 'None', 'None'),
  [ChainId.BOBA]: new Token(ChainId.BOBA, ZERO_ADDRESS, 18, 'None', 'None'),
}

export const ROCO: { [chainId in ChainId]: Token } = {
  [ChainId.BOBATEST]: new Token(ChainId.BOBATEST, ZERO_ADDRESS, 18, 'None', 'None'),
  [ChainId.BOBA]: new Token(ChainId.BOBA, ZERO_ADDRESS, 18, 'None', 'None'),
}

export const CRAFT: { [chainId in ChainId]: Token } = {
  [ChainId.BOBATEST]: new Token(ChainId.BOBATEST, ZERO_ADDRESS, 18, 'None', 'None'),
  [ChainId.BOBA]: new Token(ChainId.BOBA, ZERO_ADDRESS, 18, 'None', 'None'),
}

export const YAY: { [chainId in ChainId]: Token } = {
  [ChainId.BOBATEST]: new Token(ChainId.BOBATEST, ZERO_ADDRESS, 18, 'None', 'None'),
  [ChainId.BOBA]: new Token(ChainId.BOBA, ZERO_ADDRESS, 18, 'None', 'None'),
}

export const AVXT: { [chainId in ChainId]: Token } = {
  [ChainId.BOBATEST]: new Token(ChainId.BOBATEST, ZERO_ADDRESS, 18, 'None', 'None'),
  [ChainId.BOBA]: new Token(ChainId.BOBA, ZERO_ADDRESS, 18, 'None', 'None'),
}

export const MERKLE_AIRDROP_ADDRESS: { [chainId in ChainId]?: string } = {
  [ChainId.BOBA]: ZERO_ADDRESS,
  [ChainId.BOBATEST]: ZERO_ADDRESS
}

export const TREASURY_VESTER_ADDRESS: { [chainId in ChainId]: string } = {
  [ChainId.BOBA]: ZERO_ADDRESS,
  [ChainId.BOBATEST]: ZERO_ADDRESS
}

export const DEVFEE_VESTER_ADDRESS: { [chainId in ChainId]: string } = {
  [ChainId.BOBA]: ZERO_ADDRESS,
  [ChainId.BOBATEST]: ZERO_ADDRESS
}
export const AIRDROP_TREASURY_ADDRESS: { [chainId in ChainId]: string } = {
  [ChainId.BOBA]: ZERO_ADDRESS,
  [ChainId.BOBATEST]: ZERO_ADDRESS
}
export const LIQ_POOL_MANAGER_ADDRESS: { [chainId in ChainId]: string } = {
  [ChainId.BOBA]: ZERO_ADDRESS,
  [ChainId.BOBATEST]: ZERO_ADDRESS
}

export const MARKET_PLACE_ADDRESS: { [chainId in ChainId]?: string } = {
  [ChainId.BOBA]: '0x00000000009ddd5947b47db99785b1c669023ea7',
  [ChainId.BOBATEST]: '0x00000000009ddd5947b47db99785b1c669023ea7'
}

export const YETISWAP_NFT_COLLECTION_ADDRESS: { [chainId in ChainId]?: string } = {
  [ChainId.BOBA]: '0x0000000004bfef9b1a67aa4e15943824996c9761',
  [ChainId.BOBATEST]: '0x0000000004bfef9b1a67aa4e15943824996c9761'
}

export const YTS_FAUCET: { [chainId in ChainId]?: string } = {
  [ChainId.BOBA]: ZERO_ADDRESS,
  [ChainId.BOBATEST]: ZERO_ADDRESS
}

export const YETI_SUMMER_COLLECTION_ADDRESS = {
  [ChainId.BOBA]: ZERO_ADDRESS,
  [ChainId.BOBATEST]: ZERO_ADDRESS
}

export const HEARTS_NFT_ADDRESS = {
  [ChainId.BOBA]: ZERO_ADDRESS,
  [ChainId.BOBATEST]: ZERO_ADDRESS
}

export const BURN_ADDRESS: { [chainId in ChainId]: string } = {
  [ChainId.BOBA]: '0x000000000000000000000000000000000000dead',
  [ChainId.BOBATEST]: '0x000000000000000000000000000000000000dead'
}

const WAVAX_ONLY: ChainTokenList = {
  [ChainId.BOBA]: [WAVAX[ChainId.BOBA]],
  [ChainId.BOBATEST]: [WAVAX[ChainId.BOBATEST]]
}

// used to construct intermediary pairs for trading
export const BASES_TO_CHECK_TRADES_AGAINST: ChainTokenList = {
  ...WAVAX_ONLY,
  [ChainId.BOBA]: [...WAVAX_ONLY[ChainId.BOBA]]
}

/**
 * Some tokens can only be swapped via certain pairs, so we override the list of bases that are considered for these
 * tokens.
 */
export const CUSTOM_BASES: { [chainId in ChainId]?: { [tokenAddress: string]: Token[] } } = {
  [ChainId.BOBA]: {}
}

// used for display in the default list when adding liquidity
export const SUGGESTED_BASES: ChainTokenList = {
  ...WAVAX_ONLY,
  [ChainId.BOBA]: [...WAVAX_ONLY[ChainId.BOBA]]
}

// used to construct the list of all pairs we consider by default in the frontend
export const BASES_TO_TRACK_LIQUIDITY_FOR: ChainTokenList = {
  ...WAVAX_ONLY,
  [ChainId.BOBA]: [...WAVAX_ONLY[ChainId.BOBA], YTS[ChainId.BOBA]]
}

export const PINNED_PAIRS: { readonly [chainId in ChainId]?: [Token, Token][] } = {
  [ChainId.BOBA]: []
}

export interface WalletInfo {
  connector?: AbstractConnector
  name: string
  iconName: string
  description: string
  href: string | null
  color: string
  primary?: true
  mobile?: true
  mobileOnly?: true
}

export const SUPPORTED_WALLETS: { [key: string]: WalletInfo } = {
  INJECTED: {
    connector: injected,
    name: 'Injected',
    iconName: 'arrow-right.svg',
    description: 'Injected web3 provider.',
    href: null,
    color: '#010101',
    primary: true
  },
  METAMASK: {
    connector: injected,
    name: 'MetaMask',
    iconName: 'metamask.png',
    description: 'Easy-to-use browser extension.',
    href: null,
    color: '#E8831D'
  },
  WALLET_LINK: {
    connector: walletlink,
    name: 'Coinbase Wallet',
    iconName: 'coinbaseWalletIcon.svg',
    description: 'Use Coinbase Wallet app on mobile device',
    href: null,
    color: '#315CF5',
  },
  WALLET_CONNECT: {
    connector: walletconnect,
    name: 'Wallet Connect',
    iconName: 'walletConnectIcon.svg',
    description: 'Use Wallet Connect',
    href: null,
    color: '#315CF5',
  },
}

export const NetworkContextName = 'NETWORK'

// default allowed slippage, in bips
export const INITIAL_ALLOWED_SLIPPAGE = 50
// 60 minutes, denominated in seconds
export const DEFAULT_DEADLINE_FROM_NOW = 60 * 60

export const BIG_INT_ZERO = JSBI.BigInt(0)

// one basis point
export const ONE_BIPS = new Percent(JSBI.BigInt(1), JSBI.BigInt(10000))
export const BIPS_BASE = JSBI.BigInt(10000)
// used for warning states
export const ALLOWED_PRICE_IMPACT_LOW: Percent = new Percent(JSBI.BigInt(100), BIPS_BASE) // 1%
export const ALLOWED_PRICE_IMPACT_MEDIUM: Percent = new Percent(JSBI.BigInt(300), BIPS_BASE) // 3%
export const ALLOWED_PRICE_IMPACT_HIGH: Percent = new Percent(JSBI.BigInt(500), BIPS_BASE) // 5%
// if the price slippage exceeds this number, force the user to type 'confirm' to execute
export const PRICE_IMPACT_WITHOUT_FEE_CONFIRM_MIN: Percent = new Percent(JSBI.BigInt(1000), BIPS_BASE) // 10%
// for non expert mode disable swaps above this
export const BLOCKED_PRICE_IMPACT_NON_EXPERT: Percent = new Percent(JSBI.BigInt(1500), BIPS_BASE) // 15%

// used to ensure the user doesn't send so much ETH so they end up with <.01
export const MIN_ETH: JSBI = JSBI.exponentiate(JSBI.BigInt(10), JSBI.BigInt(16)) // .01 ETH
export const BETTER_TRADE_LINK_THRESHOLD = new Percent(JSBI.BigInt(75), JSBI.BigInt(10000))
